export const useSessionStore = () => {
    /**
     * Initializes the sessions store
     */
    const init = () => {
        window.Alpine.store("sessions", {
            _multiple: false,
            _betLimitExceeded: false,
            _insufficientBalance: false,
            _overlay: false,
            _iframeLoaded: false,
            get betLimitExceeded() {
                return this._betLimitExceeded;
            },
            set betLimitExceeded(b) {
                this._betLimitExceeded = !this._overlay && b;
            },
            get insufficientBalance() {
                return this._insufficientBalance;
            },
            set insufficientBalance(b) {
                this._insufficientBalance = !this._overlay && b;
            },
            get multiple() {
                return this._multiple;
            },
            set multiple(v) {
                this._multiple = v;
            },
            get iframeLoaded() {
                return this._iframeLoaded;
            },
            set iframeLoaded(v) {
                this._iframeLoaded = v;
            },
            clear() {
                this._insufficientBalance = false;
                this._betLimitExceeded = false;
            },
        });
    };

    return { init };
};
